import * as React from "react";
import ScreenSizes from "./ScreenSizes";
import UseWidth from "./hooks/UseWidth";

export interface Props {
    children: React.ReactNode;
}

const Mobile: React.FC<Props> = ({children}) => {
    const screenWidth = UseWidth.useWidth();

    if (screenWidth < ScreenSizes.getDesktopMinimumWidth()) {
        return (
            <>
                {children}
            </>
        );
    }

    return null;
};

export default Mobile;
